import { Box, CssBaseline, useMediaQuery } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";
import { styled } from "styled-components";
import Footer from "../../Auth/pages/Static/Footer";
import Header from "../../Auth/pages/Static/Header";
import { useSellerOrgConfig } from "../../Hooks/useSellerOrgConfig";
import { GenericRegistrationStepsComponent } from "../../components/GenericRegistrationSteps/GenericRegistrationSteps";
import AppTheme from "../../theme/AppTheme";
// Add Redux imports
import { useAppDispatch } from "../../Redux/hooks";
import { clearFormValues } from "../../Redux/Slices/userRegistrationSlice";

const UserRegistrationPageContainer = styled.div`
  background-color: #f5f5f5;
  min-height: 100dvh;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ContentSection = styled(Box)<{ isSuccessPage: boolean }>`
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 0;
`;

const formSteps = [
  "register",
  "businessDetails",
  "storeInformation",
  "bankKYC",
  // "successfull"
] as const;
export const UserRegistrationLayout: React.FC<{
  disableCustomTheme?: boolean;
}> = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [completedSteps, setCompletedSteps] = useState<string[]>([]);
  const isSuccessPage = location.pathname === "/register/successfull";
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");
  const { branding } = useSellerOrgConfig();
  const hasCustomAuthFooter = Boolean(branding.authFooterText);
  const showFooter =
    !isSuccessPage && (hasCustomAuthFooter || !isMobile || !isTablet);
  const compactMobileFooter = isMobile && hasCustomAuthFooter;

  const currentStepName = (() => {
    const path = location.pathname;
    if (path === "/register") return "register";
    const match = path.match(/^\/register\/([^/]+)/);
    return match?.[1] || "";
  })();

  const currentIndex = formSteps.indexOf(currentStepName as any);

  const goNext = (value?: any) => {
    const nextIndex = Math.min(currentIndex + 1, formSteps.length - 1);
    const nextStep = formSteps[nextIndex];
    const path =
      nextStep === "register" ? "/register" : `/register/${nextStep}`;
    navigate(path);
  };

  const goBack = () => {
    const prevIndex = Math.max(currentIndex - 1, 0);
    const prevStep = formSteps[prevIndex];
    const path =
      prevStep === "register" ? "/register" : `/register/${prevStep}`;
    navigate(path);
  };
  useEffect(() => {
    const [nav] = performance.getEntriesByType(
      "navigation"
    ) as PerformanceNavigationTiming[];
    if (nav?.type === "reload") {
      navigate("/register");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Clear form values when coming from registration page
  useEffect(() => {
    const { isRegisteredState } = location.state || {};
    if (isRegisteredState) {
      // Clear form values when coming from registration page
      dispatch(clearFormValues());
    }
  }, [dispatch, location.state]);

  return (
    <AppTheme {...props}>
      <CssBaseline />
      <UserRegistrationPageContainer>
        <Header />
        {!isSuccessPage && (
          <>
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
            ></Box>
            <GenericRegistrationStepsComponent
              completedSteps={completedSteps}
              currentStepName={currentStepName}
            />
          </>
        )}
        {isSuccessPage ? (
          <>
            <Outlet
              context={{
                goNext,
                goBack,
                setCompletedSteps,
                completedSteps,
                currentStepName,
              }}
            />
          </>
        ) : (
          <ContentSection
            isSuccessPage={isSuccessPage}
            sx={
              compactMobileFooter
                ? { pb: "72px" }
                : undefined
            }
            paddingBottom={
              compactMobileFooter
                ? undefined
                : location.pathname === "/register"
                  ? "10px"
                  : "10vh"
            }
          >
            <Outlet
              context={{
                goNext,
                goBack,
                setCompletedSteps,
                completedSteps,
                currentStepName,
              }}
            />
          </ContentSection>
        )}

        {showFooter ? (
          <Box
            sx={
              compactMobileFooter
                ? {
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 900,
                    width: "100%",
                  }
                : {
                    flexShrink: 0,
                    width: "100%",
                    mt: "auto",
                  }
            }
          >
            <Footer compactMobile={compactMobileFooter} />
          </Box>
        ) : null}
      </UserRegistrationPageContainer>
    </AppTheme>
  );
};
